import React,  {Component} from 'react';
import PropTypes from 'prop-types';
import { propTypes, reduxForm, Field, SubmissionError} from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import { UPDATE } from 'admin-on-rest';
import restClient from '../restClient';

import { Card, CardText } from 'material-ui/Card';
import { List } from 'material-ui/List';
import { DateField, BooleanField, translate, TextField as TextField2 } from 'admin-on-rest';
import CHUrlField from '../utils/CHUrlField'
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { push as pushAction } from 'react-router-redux';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { withStyles } from 'material-ui/styles';
import { initialize } from 'redux-form';
import RichTextInput from 'aor-rich-text-input';
import CHRichTextInput from '../utils/CHRichTextInput';

//form validations
//allow a-z0-9 and dash (-) and backslash (\\) and forward slash (\/): [a-z0-9\-\\\/]
const website = value => value && !/^(http\:\/\/|https\:\/\/)+([a-z0-9][a-z0-9\-]*\.)+[a-z0-9\-\\\/]*$/i.test(value) ?
  'Ongeldig website adres' : undefined
const required = value => value ? undefined : 'Verplicht'
const maxLength = max => value =>
  value && value.length > max ? `Max length of ${max} characters exceeded` : undefined
const maxLength25 = maxLength(25)

const styles = {};

//https://redux-form.com/7.4.2/examples/syncvalidation/

//see http://redux-form.com/6.4.3/examples/material-ui/

const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => (
  <TextField 
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    {...custom}
  />
)

const renderSelectField = ({ input, label, meta: { touched, error }, children, ...custom }) => (
  <SelectField
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    onChange={(event, index, value) => input.onChange(value)}
    children={children}
    {...custom}/>
)

const validate = (data, props) => {
  	const errors = {}
 	
	//go through every plan
	for(var i=0;i<props.plans.length;i++) {
		var planFields = props.plans[i].fields;	
		
		//for every plan, go through every field and execute field validations
		for(var j=0;j<planFields.length;j++) {
			//field information and properties (required, website, url, type, etc)
			//this is returned from rails as params for the fields
			var field = planFields[j];
			
			//the name of the field in the redux form = (field.key_plan.id)
			var fieldnameForForm =field.key+'_'+(i+1);
			
			//execute validations for field 
			if(field.required && !data[fieldnameForForm]) {
				errors[fieldnameForForm] = 'Required';
			}
			
		
		}
	}
	
	
	return errors; 
}

class PlansForm extends Component {
	state = {};
	
	constructor(props){
	    super(props);
		this.props.dispatch(initialize('plansForm', this.props.fieldvalues));
  	}
	
	componentWillMount() {
		//
    }
	
	saveDetails = ({...formData }) => {
    	
		const { record, plans, showNotification, push } = this.props;
		
		
		
		//get HTML from RTE for description
		
		restClient(UPDATE, 'member/ad_plans_save', {id: record.id, data: {fieldvalues: formData}} )
		   .then((response) => {				
				//push('/member/ad_complete/'+response.data.id);				
			})
			.catch((e) => {
				console.error(e);
				showNotification('cloudhints.error_try_again','warning')
			});
			
    }
	
   
   	render() {
	    const { record, plans, translate, handleSubmit} = this.props;
		
		return (
			<form onSubmit={handleSubmit(this.saveDetails)}>
				<div className="row form-horizontal form-fullwidth">
					<div className=" col col-35">						
						<h3>Welke pakketten biedt u aan?</h3>
						
					</div>			
				</div>
				<div className="row "><br/>
					 {plans.map(plan =>
					 	 <Card key={plan.id} style={styles.cardStyle}>          
							<CardText style={styles.cardText}>
								{plan.fields.map(field =>
									<Field
										key={`${field.key}_${plan.id}`}
										name={`${field.key}_${plan.id}`}
										component={renderTextField}
										type="text"
										label={field.label}	
										/>
								)}		
							</CardText>           
						</Card>
					 
					 )}					
				</div>
								
				<RaisedButton type="submit" primary label={translate('cloudhints.save')} />					
			</form>
		 );
    }
}


PlansForm = reduxForm({
  form: 'plansForm' ,
  validate
})(PlansForm)

PlansForm = connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
}
)(PlansForm)

export default translate(PlansForm)


// WEBPACK FOOTER //
// ./src/ads/AdPlans_Form.js